import {
  AxleCapacityField,
  AxleFormName,
  AxleGroupField,
  AxleIdField,
  AxleSpacingField,
  AxleTypeField,
  AxleWeightField,
  AxleWidthField,
  IsSteeringAxleField,
  SuspensionTypeField,
  TireCountField,
  TireRatingField,
  TireSizeField,
} from '@src/permitField/AxleInformationFields';
import { TractorAxlesFormUtils } from '@src/permitField/TractorAxlesFormUtils';
import { TractorIdField } from '@src/permitField/TractorInformationFields';
import {
  TrailerIdField,
  TrailersFormName,
} from '@src/permitField/TrailerInformationFields';
import { newTractorKey } from '@src/tractor/TractorSelector';
import { newTrailerKey } from '@src/trailer/TrailerSelector';

//The team favored using sanitization pre-sending data to simplify form management and maintainability.
// Handling the data as close to the input as possible is still preferable
// In case of intricate components interactions on the same form field, sanitization might be an acceptable option
export const sanitizeEditOrderInputs = (
  data: Record<string, unknown>,
): Record<string, unknown> => {
  if (data[TrailersFormName]) {
    const trailers = data[TrailersFormName] as Record<string, unknown>[];

    trailers.forEach((trailer, i) => {
      if (trailer[TrailerIdField.fieldName] === newTrailerKey) {
        // @ts-ignore
        data[TrailersFormName][i][TrailerIdField.fieldName] = undefined;
      }
    });
  }
  if (data[TractorIdField.fieldName] === newTractorKey) {
    data[TractorIdField.fieldName] = undefined;
  }

  data = sanitizeAxlesData(data);

  return data;
};

const sanitizeAxlesData = (
  data: Record<string, unknown>,
): Record<string, unknown> => {
  const tractorAxles = data[TractorAxlesFormUtils.fieldName];
  let sanitizedTractorAxles = [];
  if (tractorAxles) {
    // @ts-ignore
    sanitizedTractorAxles = sanitizeTractorAxleData(
      sanitizeAxleData(tractorAxles[AxleFormName as keyof unknown]),
    );
  }

  const trailers = data[TrailersFormName];

  if (Array.isArray(trailers)) {
    trailers.forEach((trailer, i) => {
      // @ts-ignore
      data[TrailersFormName][i][AxleFormName] = sanitizeAxleData(
        trailer[AxleFormName],
      );
    });
  }

  return {
    ...data,
    [TractorAxlesFormUtils.fieldName]: tractorAxles
      ? {
          [AxleFormName]: sanitizedTractorAxles,
        }
      : undefined,
  };
};

const sanitizeTractorAxleData = (axles: unknown) => {
  if (Array.isArray(axles)) {
    return axles.map((axle, index) => {
      const { [AxleSpacingField.fieldName]: _, ...withoutSpacing } = axle;
      return {
        ...withoutSpacing,
        [AxleSpacingField.fieldName]:
          index === 0 ? undefined : axle.axleSpacing,
      };
    });
  }
};

const sanitizeAxleData = (axles: unknown) => {
  if (Array.isArray(axles)) {
    return axles.map((axle) => ({
      [AxleIdField.fieldName]: axle.axleId ?? undefined,
      [AxleWeightField.fieldName]: axle.axleWeight ?? undefined,
      [AxleCapacityField.fieldName]: axle.axleCapacity ?? undefined,
      [AxleWidthField.fieldName]: axle.axleWidth ?? undefined,
      [TireCountField.fieldName]: axle.tireCount ?? undefined,
      [TireRatingField.fieldName]: axle.tireRating ?? undefined,
      [TireSizeField.fieldName]: axle.tireSize ?? undefined,
      [SuspensionTypeField.fieldName]: axle.suspensionType ?? undefined,
      [AxleGroupField.fieldName]: axle.axleGroup ?? undefined,
      [IsSteeringAxleField.fieldName]: axle.isSteeringAxle ?? undefined,
      [AxleSpacingField.fieldName]: axle.axleSpacing ?? undefined,
      [AxleTypeField.fieldName]: axle.axleType ?? undefined,
    }));
  }
};
